<main id="las-botellas-main2" style="--ban: url('../assets/fondo-producto-detalle.png') no-repeat center; --ban-mob: url('../assets/productos_gordons_desktop') no-repeat center;">
  <app-product-plans [config]="config"></app-product-plans>
</main>